angular.module('picmonicng').directive('workflowCommentFeed', [
  function () {
    return {
      restrict: 'E',
      scope: {
        slug: '@',
      },
      controller: [
        '$scope',
        'CommentsResource',
        'UserService',
        'WorkflowResource',
        function ($scope, CommentsResource, UserService, WorkflowResource) {
          $scope.loading = true;
          $scope.UserService = UserService;
          $scope.comments = CommentsResource.query({ slug: $scope.slug });
          $scope.comments.$promise.then(function (data) {
            $scope.loading = false;
          });
        },
      ],
      templateUrl: '/templates/directives/workflow-comment-feed.html',
    };
  },
]);
